module.exports = __webpack_public_path__ + "static/media/MinnieGary.bc209936.jpg";